import { render, staticRenderFns } from "./CreateAccountForm.vue?vue&type=template&id=5c056f4d"
import script from "./CreateAccountForm.vue?vue&type=script&lang=ts"
export * from "./CreateAccountForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports